<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Clientes | Edição" />
    <v-row justify="center" align="center">
      <v-col>
        <v-card class="pa-8">
          <form-users :user="user" @submit="submit" />
          <v-divider class="my-6" />
          <user-orders v-if="user" :user="user" />
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script setup lang="ts">
import TPageTitle from '@/components/TPageTitle.vue'
import { useSnackBar } from '@/stores/snackbar'
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useLoader } from '@/stores/loader'
import UserService from '@/services/UserService'
import User from '@/types/User'
import FormUsers from './form-users.vue'
import UserOrders from './partial/user-orders.vue'

const route = useRoute()
const snackbar = useSnackBar()
const loader = useLoader()

const user = ref<User>()

onMounted(() => {
  fetch()
})

async function fetch() {
  try {
    loader.increment()
    const response = await new UserService().show(route.params.id as string)
    user.value = response.data.data
  } catch {
    snackbar.show('Erro ao buscar detalhes da compra', 'error')
  } finally {
    loader.decrement()
  }
}

async function submit(model: User) {
  try {
    loader.increment()
    const response = await new UserService().update(model)
    user.value = response.data.data
    snackbar.show('Cadastro editado com sucesso', 'success')
  } catch {
    snackbar.show('Não foi possível atualizar os dados do cliente', 'error')
  } finally {
    loader.decrement()
  }
}
</script>
